import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";

export const groupStyle = style({
  //
});

export const groupContainerStyle = recipe({
  base: {
    display: "inline-flex",
    position: "relative",
  },
  variants: {
    direction: {
      horizontal: {
        flexDirection: "row",
      },
      vertical: {
        flexDirection: "column",
      },
    },
  },
});
